import { sameArray, camelCase, isType } from './utils';

const utils = {
  sameArray,
  camelCase,
  isType,
};

export { utils };
